import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
@Component({
  selector: 'confirmation-dialog',
  templateUrl: '../../pages/confirmation-dialog/confirmation-login-dialog.html',
})
export class ConfirmationLoginDialog 
{
    message: string = "¿Esta seguro de anular la solicitud?"
    confirmButtonText = "Si"
    cancelButtonText = "No"
    
    constructor(
    @Inject(MAT_DIALOG_DATA) private data: any, public router: Router,
    private dialogRef: MatDialogRef<ConfirmationLoginDialog>) 
    {
        if(data)
        {
            this.message = data.message || this.message;
            
            if (data.buttonText) 
            {
                this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
                this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
            }
        }
    }

    onConfirmClick(): void { this.dialogRef.close(true); }

    onRejectClick(): void { 
        this.router.navigate(['/login'])   

       this.dialogRef.close(false);
    
    }
}